class CartRenderer {
  constructor() {
    this.cartContainer = document.getElementById("dynamic-cart-container");
  }

  async refreshCart() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      this.updateCartUI(cart);
    } catch (error) {
      console.error("Error refreshing cart:", error);
    }
  }

  updateCartUI(cart) {
    if (!this.cartContainer) return;

    let cartHTML = `
      <div class="cart-items-wrapper">
        <form action="/cart" method="post" id="cart-form" class="cart-form">
          <div class="cart-items">
            ${
              cart.item_count > 0
                ? cart.items
                    .map(
                      (item) => `
                <div class="cart-item" data-cart-item-id="${item.id}">
                  <div class="cart-item-content">
                    <div class="title-row">
                      <h3>${item.title}</h3>
                      <button type="button" class="remove-item" data-item-id="${
                        item.id
                      }">×</button>
                    </div>
                    
                    <div class="price-quantity-row">
                      <div class="quantity-controls">
                        <button type="button" class="quantity-btn minus" data-item-id="${
                          item.id
                        }">-</button>
                        <input type="number" 
                               name="updates[]" 
                               value="${item.quantity}" 
                               min="0" 
                               data-item-id="${item.id}"
                               class="quantity-input">
                        <button type="button" class="quantity-btn plus" data-item-id="${
                          item.id
                        }">+</button>
                      </div>
                      <p class="item-price">${this.formatMoney(item.price)}</p>
                    </div>
                  </div>
                </div>
              `
                    )
                    .join("")
                : '<p class="empty-cart">Your cart is empty</p>'
            }
          </div>
          ${
            cart.item_count > 0
              ? `
            <div class="cart-summary">
              <div class="summary-row">
                <span>SUBTOTAL</span>
                <span>${this.formatMoney(cart.total_price)}</span>
              </div>
              <div class="line"></div>
              <div class="summary-row total">
                <span>TOTAL</span>
                <span>${this.formatMoney(cart.total_price)}</span>
              </div>
            </div>
          `
              : ""
          }
        </form>
      </div>
    `;

    this.cartContainer.innerHTML = cartHTML;

    const cartCountElements = document.querySelectorAll(".cart-count");
    cartCountElements.forEach((element) => {
      element.textContent = cart.item_count;
    });

    new CartManager();
  }

  formatMoney(cents) {
    return `${(cents / 100).toFixed(2)} EUR`;
  }
}

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmit.bind(this));
    this.variantSelect = this.querySelector('select[name="variant-select"]');
    this.cartRenderer = new CartRenderer();

    try {
      this.productData = JSON.parse(this.dataset.product || "{}");
    } catch (e) {
      console.error("Error parsing product data:", e);
      this.productData = null;
    }

    if (this.variantSelect) {
      this.variantSelect.addEventListener(
        "change",
        this.onVariantChange.bind(this)
      );
      this.onVariantChange();
    }
  }

  onVariantChange() {
    if (!this.productData || !this.variantSelect) return;

    const selectedValue = this.variantSelect.value;
    const selectedVariant = this.productData.variants.find(
      (variant) => variant.id.toString() === selectedValue
    );

    if (selectedVariant) {
      const variantInput = this.form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = selectedVariant.id;
      }
      const priceElement = this.querySelector(".price");
      if (priceElement && selectedVariant.price) {
        priceElement.textContent = this.formatMoney(selectedVariant.price);
      }
    }
  }

  async onSubmit(event) {
    event.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    try {
      const formData = new FormData(this.form);
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: formData,
      });

      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();
      await this.cartRenderer.refreshCart();
    } catch (error) {
      console.error("Error:", error);
    } finally {
      if (submitButton) submitButton.disabled = false;
    }
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }
}

class CartManager {
  constructor() {
    this.form = document.getElementById("cart-form");
    if (!this.form) return;
    this.cartRenderer = new CartRenderer();
    this.bindEvents();
  }

  bindEvents() {
    this.form.addEventListener("click", (event) => {
      const target = event.target;

      if (target.classList.contains("quantity-btn")) {
        this.handleQuantityButton(event);
      } else if (target.classList.contains("remove-item")) {
        this.handleRemoveItem(event);
      } else if (target.classList.contains("checkout-button")) {
        window.location.href = "/checkout";
      }
    });

    this.form.addEventListener("change", (event) => {
      if (event.target.classList.contains("quantity-input")) {
        this.handleQuantityChange(event);
      }
    });
  }

  handleQuantityButton(event) {
    const btn = event.target;
    const itemId = btn.dataset.itemId;
    const input = document.querySelector(`input[data-item-id="${itemId}"]`);
    const currentValue = parseInt(input.value);

    if (btn.classList.contains("plus")) {
      input.value = currentValue + 1;
    } else {
      input.value = Math.max(0, currentValue - 1);
    }

    this.updateCart(itemId, input.value);
  }

  handleQuantityChange(event) {
    const input = event.target;
    const itemId = input.dataset.itemId;
    this.updateCart(itemId, input.value);
  }

  handleRemoveItem(event) {
    const btn = event.target;
    const itemId = btn.dataset.itemId;
    this.updateCart(itemId, 0);
  }

  async updateCart(itemId, quantity) {
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: itemId,
          quantity: parseInt(quantity),
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      await this.cartRenderer.refreshCart();
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  }
}

customElements.define("product-form", ProductForm);

document.addEventListener("DOMContentLoaded", () => {
  new CartManager();
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(initializeProductSlideshow, 1000);
});

function initializeProductSlideshow() {
  $(".product-card-slideshow").each(function () {
    if (!$(this).hasClass("slick-initialized")) {
      $(this).slick({
        dots: true,
        infinite: false,
        lazyLoad: "ondemand",
        arrows: false,
        adaptiveHeight: false,
      });
    }
  });
}

document.querySelector("#header-svg").addEventListener("click", function () {
  window.location.href = "https://fuerdiekinder.eu/";
});

document.addEventListener("DOMContentLoaded", function () {
  const myhtml = document.querySelector("html");
  const footer = document.querySelector("footer");
  const header = document.querySelector(".header");
  const body = document.querySelector("body");
  const headerContainer = document.querySelector(".header-container");
  const headerSVG = document.getElementById("header-svg");
  const shop = document.querySelector(".shop");

  const isHomepage =
    window.location.pathname === "/" ||
    window.location.pathname === "" ||
    window.location.href.endsWith("fuerdiekinder.eu/");

  if (!isHomepage) {
    header.style.display = "flex";
    header.style.flexDirection = "row";
    header.style.justifyContent = "center";
    header.style.opacity = "1";
    footer.style.opacity = "1";
    return;
  } else {
    body.classList.add("shopbody");
    header.classList.add("shopheader");
    footer.classList.add("shopfooter");
  }

  function centerHeader() {
    const windowWidth = window.innerWidth;
    let headerWidth = 272;
    const windowHeight = window.innerHeight;
    let headerHeight = 80;

    if (headerWidth === 0 || headerHeight === 0) {
      headerContainer.style.display = "block";
      headerWidth = headerContainer.offsetWidth;
      headerHeight = headerContainer.offsetHeight;
    }

    const xOffset = (windowWidth - headerWidth) / 2;
    const yOffset = (windowHeight - headerHeight) / 2;

    return {
      xOffset,
      yOffset,
    };
  }

  const initialDimensions = centerHeader();

  function starterFunction() {
    const dimensions = centerHeader();

    const startBlur = 12;
    const duration = 500;
    let startTime;

    headerSVG.style.filter = `blur(${startBlur}px)`;

    headerContainer.style.transform = `translate(${dimensions.xOffset}px, ${dimensions.yOffset}px)`;

    function animateBlur(currentTime) {
      if (!startTime) startTime = currentTime;
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const easeProgress = cubicBezier(0.4, 0, 0.2, 1, progress);
      const currentBlur = startBlur * (1 - easeProgress);

      headerSVG.style.filter = `blur(${currentBlur}px)`;

      if (elapsedTime < duration) {
        requestAnimationFrame(animateBlur);
      }
    }

    setTimeout(() => {
      header.style.display = "block";
      header.classList.remove("hide");
      header.classList.add("animate-short");
      header.style.opacity = "1";
      headerContainer.classList.add("animate");
      shop.style.transition = "opacity 1s ease";
    }, 100);

    setTimeout(() => {
      startTime = null;
      requestAnimationFrame(animateBlur);
      const newDimensions = centerHeader();
      headerContainer.style.transform = `translate(${newDimensions.xOffset}px, 0)`;
    }, 500);

    setTimeout(() => {
      shop.style.display = "block";
      footer.style.display = "block";

      const fadeInDuration = 100;
      const fadeStart = performance.now();

      function fadeIn(currentTime) {
        const elapsed = currentTime - fadeStart;
        const progress = Math.min(elapsed / fadeInDuration, 1);
        shop.style.opacity = progress;
        footer.style.opacity = progress;

        if (progress < 1) {
          requestAnimationFrame(fadeIn);
        }
      }

      requestAnimationFrame(fadeIn);

      setTimeout(() => {
        body.classList.remove("shopbody");
      }, 100);
    }, 1000);
  }

  window.addEventListener("load", () => {
    requestAnimationFrame(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      setTimeout(() => {
        starterFunction();
      }, 100);
    });
  });

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const dimensions = centerHeader();
      headerContainer.style.transform = `translate(${dimensions.xOffset}px, 0)`;
      headerContainer.classList.remove("animate");
    }, 100);
  });

  function cubicBezier(x1, y1, x2, y2, t) {
    const cx = 3 * x1;
    const bx = 3 * (x2 - x1) - cx;
    const ax = 1 - cx - bx;
    const cy = 3 * y1;
    const by = 3 * (y2 - y1) - cy;
    const ay = 1 - cy - by;

    const t2 = t * t;
    const t3 = t2 * t;
    return ay * t3 + by * t2 + cy * t;
  }
});

document.addEventListener("click", function (e) {
  if (e.target.closest(".quick-add__submit")) {
    setTimeout(function () {
      const cartHeading = document.getElementById("cart-heading");
      if (cartHeading) {
        window.scrollTo({
          top: cartHeading.offsetTop - 50,
          behavior: "smooth",
        });
      }
    }, 500);
  }
});
